export default class NewPasswordFormModel {
  token = ''

  password = ''

  confirmPassword = ''
}
